'use client'

import { useContext, useState } from 'react'

import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'
import {
  OfflineContext,
  OfflineContextType
} from 'shared/ui/Offline/OfflineContext'
import toast from 'shared/ui/utils/toast'
import { getApiErrors } from 'shared/utils/errors'

import { useCheckDeliveryCoverage } from '../../hooks/useCheckDeliveryCoverage'
import { DeliveryArea } from '../../submodules/area'
import { PostalDeliveryState } from '../../types'
import DeliveryAreaForm from '../DeliveryAreaForm'

import styles from './DeliveryAreaGateModal.module.scss'

interface DeliveryAreaGateModalProps {
  open: boolean
  onClose: () => void
  callback: (response: PostalDeliveryState) => void
}

const DeliveryAreaGateModal = ({
  open,
  onClose,
  callback
}: DeliveryAreaGateModalProps) => {
  const {
    update,
    isDeliveryPossible,
    postalCodeAndCityContext,
    clearDeliveryPossible
  } = useCheckDeliveryCoverage(open)

  const [isLoading, setIsLoading] = useState(false)

  const { isOnline, temporaryOfflineNotificationError } = useContext(
    OfflineContext
  ) as OfflineContextType

  const handleSubmit = async (values: DeliveryArea) => {
    if (isOnline) {
      setIsLoading(true)

      try {
        const response = await update({
          postalCode: values.postalCode,
          city: values.city
        })

        if (response?.isSupported) {
          onClose()
          callback(response)
          toast.success('Obsługujemy wybrany obszar. Udanych zakupów!')
        }
        setIsLoading(false)
      } catch (error) {
        toast.error(getApiErrors(error))
        setIsLoading(false)
      }
    } else {
      temporaryOfflineNotificationError()
    }
  }

  return (
    <Modal id='check-postal-code-modal' onClose={onClose} open={open}>
      <ModalTitle>Sprawdź dostępność dostawy</ModalTitle>
      <ModalDescription>
        Aby dodać produkt do koszyka, podaj swój kod pocztowy i&nbsp;miejscowość
      </ModalDescription>
      <DeliveryAreaForm
        className={styles.formWrapper}
        initValues={{
          postalCode: postalCodeAndCityContext.postalCode,
          city: postalCodeAndCityContext.city
        }}
        isLoading={isLoading}
        onSubmit={handleSubmit}
        onChange={clearDeliveryPossible}
        buttonText='Sprawdź'
        deliveryPossible={isDeliveryPossible}
      />
    </Modal>
  )
}

export default DeliveryAreaGateModal
